import { type EventTag, mapTag } from '../tags/tags.mappers';

import type { EventResponse, GuestSuggestionDto } from './events.dto';

/** A guest from the vessel's past events, ranked by the service by frequency and recency. */
export interface PastGuest {
  personId: string;
  name: string;
  eventsCount: number;
  /** How many of those invitations they accepted — "a regular" when above zero. */
  acceptedCount: number;
  lastEventTitle: string;
  /** The guests they brought to their last event; inviting them again brings the same party. */
  additionalGuests: number;
}

export const mapGuestSuggestion = ({
  person_id,
  name,
  events_count,
  accepted_count,
  last_event_title,
  last_additional_guests,
}: GuestSuggestionDto): PastGuest => ({
  personId: person_id,
  name,
  eventsCount: events_count,
  acceptedCount: accepted_count,
  lastEventTitle: last_event_title,
  additionalGuests: last_additional_guests ?? 0,
});

export const eventTags = (event: EventResponse): EventTag[] => (event.tags ?? []).map(mapTag);
